import React, { Component, useState, useRef } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Table, Modal, Input, Divider, Tooltip, Col, Row, Button, message, Select } from 'antd'
import styles from './skillsDialog.module.scss'
import dayjs from 'dayjs'
import * as apis from '@/apis'
const { Option } = Select;
const { TextArea } = Input;


@Form.create()
class MgroupsDialog extends Component {
  state = {
    loading: false,
  }

  handleSubmit = e => {
    const { tenantId, type, mgroups = {}, ismodify, submitCallback, onSuccess } = this.props
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }

      this.setState({ loading: true })
      if (ismodify !== "modify") {
        apis.createSkills({
          name: values.name,
          desc: values.desc.toString(),
        }).then(result => {
          message.success('添加成功')
          this.props.form.resetFields()
          onSuccess(result)
          submitCallback && submitCallback()

        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
          this.setState({
            loading: false
          })
        })
      } else {
        apis.updateSkills(mgroups._id, {
          name: values.name,
          desc: values.desc.toString(),
        }).then(result => {
          message.success('修改成功')
          this.props.form.resetFields()
          onSuccess(result)
          submitCallback && submitCallback()

        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
          this.setState({
            loading: false
          })
        })


      }
    });
  }

  fetch = async () => {
    this.setState({ loading: true })
    this.setState({
      loading: false
    })
  }

  componentDidMount() {
    this.fetch()
  }

  render() {
    const { type, mgroups = {}, ismodify } = this.props
    const { getFieldDecorator, validateFields, getFieldValue } = this.props.form
    const disabled = this.state.loading
    const mingzi = type === 'staff' ? '员工' : '客服'

    return (
      <div>
        <Form layout="inline" onSubmit={this.handleSubmit}>
          <Row>
            <Col span={24}>
              <Form.Item
                label="分类名称"
                required>
                {getFieldDecorator('name', {
                  initialValue: mgroups.name,
                  rules: [
                    {
                      required: true,
                      message: '请输入分类名称',
                    },
                  ],
                })(
                  <Input style={{ width: 300 }} autoFocus placeholder="请输入分类名称" />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                label="分类描述"
                required>
                {getFieldDecorator('desc', {
                  initialValue: mgroups.desc,
                  rules: [
                    {
                      required: true,
                      message: '请输入分类描述',
                    },
                  ],
                })(
                  <TextArea style={{ width: 300 }} autoFocus placeholder="请输入分类描述" />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Form.Item style={{display:"block", marginTop: 10,textAlign:"center"}}>
            <Button type="primary" disabled={disabled} htmlType="submit">{ismodify === "modify" ? "确认修改" : "添加分类"}  </Button>
          </Form.Item>
        </Form>
      </div>
    )
  }
}

const TenantInfoDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={480}
    style={{ top: 30 }}
    visible={isOpen}
    onCancel={hide}>
    <MgroupsDialog onSuccess={hide} {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'SKILLS_DIALOG',
})(TenantInfoDialog)
